import { aggregateSlice, cartSlice, convert, getAggregate, getAggregateMultiRfm, sharedSlice } from './slices';

export const Actions = {
  convert,
  getAggregate,
  getAggregateMultiRfm,
  ...aggregateSlice.actions,
  ...cartSlice.actions,
  ...sharedSlice.actions,
};
